import Alpine from "alpinejs";

interface DynamicSticky {
	position: number;
	scrollable: boolean;

	init: CallableFunction;
	setMeasurements: CallableFunction;
	handleScroll: CallableFunction;
}

const dynamicSticky = (padding = 0): DynamicSticky => {
	return {
		position: 0,
		scrollable: false,

		init(): void {
			this.setMeasurements();

			if (this.$el) {
				new IntersectionObserver(
					([entry]) => (this.scrollable = entry.isIntersecting),
					{ threshold: 1 },
				).observe(this.$el);
			}

			this.$nextTick(() => {
				window.addEventListener("resize", () => this.setMeasurements());
				window.addEventListener("scroll", () => this.handleScroll());
			});
		},

		setMeasurements(): void {
			if (this.$el) this.position = window.scrollY;
		},

		handleScroll(): void {
			if (this.scrollable && this.$el) {
				this.$el.scrollTo({
					top: this.$el.scrollTop + window.scrollY - this.position,
					behaviour: "instant",
				});
				this.position = window.scrollY;
			}
		},
	};
};

Alpine.data("dynamicSticky", dynamicSticky);
